// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__3HeZB","card":"Login_card__19u4q","error":"Login_error__WD-gA","header":"Login_header__33r2R","loginFormButton":"Login_loginFormButton__xnL3O"};